import APRButton from './APRButton';
import useAPRs from './useAPRs';

const APRs: React.FunctionComponent = function () {
  const { splitKeys } = useAPRs();
  if (!splitKeys) return null;
  return (
    <>
      <h3 className="text-14-22-b md:text-16-20-b mb-2">
        Select your preferred APR
      </h3>
      <div className="flex flex-col gap-y-4">
        {splitKeys.map((splitKey) => (
          <APRButton
            splitKey={splitKey}
            key={`${splitKey.apr}-${splitKey.financeType}`}
          />
        ))}
      </div>
    </>
  );
};

export default APRs;
